














































import api from '@/lib/api';
import { Article } from '@/lib/types';
import Vue from 'vue';

export default Vue.extend({
    data(){
        return {
            articles: [] as Article[],
            pages: 1,
            current_page: 1,
            current_article: {} as Article,
            current_index: -1,
            current_pdf: {} as File,
            message: ''
        }
    },
    async mounted(){

        this.load();       

    },
    methods: {
        async confirm(){

            this.message = "";
            const work = new Array<Promise<any>>();

            if(this.current_pdf) work.push(this.awsUpload())
            work.push(this.updateArticle());

            try{

                await Promise.all(work);
                this.message = "articolo modificato con successo!"
                await this.load();
                this.current_article = this.articles[this.current_index];

            }catch(err){
                alert("di' a cippi che è successo un casino")
            }

        },
        async updateArticle(){

            const response = await api.media.articles.update(this.current_article.id, this.current_article.title, this.current_article.description);
            if(response.err) throw new Error(`errore durante l'aggiornamento dell'articolo`)
            return;

        },
        async awsUpload(){

            const signed_url = await api.media.articles.getSignedUrl(this.current_article.id);
            if(signed_url.err) throw new Error(`errore durante l'upload dell'articolo`)

            await fetch(signed_url.ok!.value.url, {
                method: "PUT",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                body: this.current_pdf
            })

        },
        async loadNewFile(){

            const input = document.getElementById('pdf')! as HTMLInputElement;
            if(!input.files) return;

            this.current_pdf = input.files[0];

        },
        async loadFileModal(){

            const input = document.getElementById('pdf');
            input?.click();

        },
        async loadFile(){
            const article_pdf = await api.media.articles.loadPDF(this.current_article.id);
            if(article_pdf.err) return alert("di' a cippi che è successo un casino");

            window.open(article_pdf.ok!.value);
        },
        async loadArticle(id: string){

            const article = await api.media.articles.load(id);
            if(article.err) return alert("di' a cippi che è successo un casino");

            this.current_article = article.ok!.value;
            this.current_index = this.articles.findIndex(article => article.id === id);
            

        },
        async load(){
            const page = this.$route.query["page"];
            this.current_page = Number.parseInt(page?.toString()) || 1;
            const stuff = await api.media.articles.getAll(this.current_page);
            if(stuff.err) return alert("di' a cippi che è successo un casino");
            
            this.pages = stuff.ok!.value.pages;
            this.articles = stuff.ok!.value.articles.map((article: Article) => { 

                article.created_at = new Date(article.created_at).toLocaleString();
                article.updated_at = new Date(article.updated_at).toLocaleString();
                return article;

            }); 
        }
    }
})
